import { useColorContext } from '../contexts/ColorContext';
import { ColorFavoritesPanel } from '../components/ColorFavoritesPanel';

export function FavoritesTool() {
  const { setInput, result, isFavorited } = useColorContext();

  return (
    <ColorFavoritesPanel
      onSelectColor={setInput}
      currentHex={result?.hex ?? ''}
      isFavorited={isFavorited}
    />
  );
}
